import {useCommands} from "../commands/useCommands";

export const useMessageHandler = () => {
  const { run } = useCommands()

  const handler = async (
    message: string
  ): Promise<void> => {
    await run(message)
  }

  return {
    handleMessage: handler
  }
}